/* Patitas de Papel · «Escribe su historia» (oct 2026)
   La persona escribe sobre las páginas 8 y 9 reales del libro y puede guardar una imagen para compartir.
   La foto nunca sale del navegador. */
(function () {
  'use strict';
  if (window.__ppEscribe) return;
  window.__ppEscribe = true;

  var FONT = 'PP Caveat';
  var PEN = '#1f3b7a';
  // Geometría en píxeles de una página de 1000 x 1500 (medida sobre el PDF de diagramación)
  var GEO = {
    p8: {
      fields: [
        { k: 'donde', x: 90, y: 279, w: 780, h: 68, fs: 44, ph: 'Ej.: en un refugio de Maipú', lbl: '¿Dónde estaban?' },
        { k: 'quien', x: 90, y: 418, w: 780, h: 68, fs: 44, ph: 'Ej.: mi hermana lo encontró', lbl: '¿Quién lo trajo?' },
        { k: 'adoptado', x: 90, y: 557, w: 780, h: 69, fs: 44, ph: 'Elige abajo o escríbelo', lbl: '¿Fue adoptado, rescatado o llegó solo?' },
        { k: 'eligio', x: 90, y: 696, w: 780, h: 69, fs: 44, ph: 'Elige abajo o escríbelo', lbl: '¿Te eligió o tú a él?' }
      ],
      foto: { x: 90, y: 842, w: 781, h: 489 }
    },
    p9: {
      fields: [
        { k: 'nombre', x: 128, y: 242, w: 780, h: 69, fs: 60, w8: 700, ph: 'Escribe su nombre aquí ✍️', lbl: '¿Cuál es su nombre?' },
        { k: 'porque', x: 128, y: 382, w: 780, h: 69, fs: 44, ph: 'Porque…', lbl: '¿Por qué se lo pusiste?' },
        { k: 'apodo1', x: 128, y: 527, w: 780, h: 61, fs: 42, ph: 'Sus apodos: Gordo, Señor Bigotes…', lbl: 'Apodo 1' },
        { k: 'apodo2', x: 128, y: 588, w: 780, h: 70, fs: 42, ph: '', lbl: 'Apodo 2' },
        { k: 'apodo3', x: 128, y: 658, w: 780, h: 69, fs: 42, ph: '', lbl: 'Apodo 3' }
      ],
      tags: {
        michi: [{ x: 720, y: 906, r: 7, s: 31, max: 112 }, { x: 338, y: 1046, r: 5, s: 19, max: 62 }, { x: 340, y: 1241, r: -6, s: 31, max: 112 }, { x: 670, y: 1251, r: 0, s: 19, max: 62 }],
        pupi: [{ x: 727, y: 879, r: 13, s: 31, max: 120 }, { x: 341, y: 1028, r: 13, s: 23, max: 88 }, { x: 336, y: 1224, r: -12, s: 31, max: 120 }, { x: 673, y: 1232, r: -1, s: 24, max: 98 }]
      }
    }
  };
  var CHIPS = {
    adoptado: ['Adoptado', 'Rescatado', 'Llegó solo', 'Nació en casa'],
    eligio: ['Me eligió', 'Lo elegí yo', 'Nos elegimos']
  };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) for (var a in attrs) { if (a === 'class') n.className = attrs[a]; else if (a === 'style') n.setAttribute('style', attrs[a]); else n.setAttribute(a, attrs[a]); }
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(s, max) { return String(s || '').replace(/[\u0000-\u001f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, max || 40); }
  function track(accion, extra) {
    try {
      var d = { accion: accion }; if (extra) for (var k in extra) d[k] = extra[k];
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pp_escribe', d);
    } catch (e) {}
  }
  function store(k, v) { try { if (v) sessionStorage.setItem(k, v); else sessionStorage.removeItem(k); } catch (e) {} }

  var fontPromise = null;
  function loadFont(url) {
    if (fontPromise) return fontPromise;
    if (!url || !window.FontFace || !document.fonts) { fontPromise = Promise.resolve(); return fontPromise; }
    try {
      var ff = new FontFace(FONT, 'url(' + url + ') format("woff2")', { weight: '400 700', style: 'normal', display: 'swap' });
      document.fonts.add(ff);
      fontPromise = ff.load().then(function () { return document.fonts.load('700 40px "' + FONT + '"'); }).catch(function () {});
    } catch (e) { fontPromise = Promise.resolve(); }
    return fontPromise;
  }
  function loadImg(src, cors) {
    return new Promise(function (res, rej) {
      var im = new Image();
      if (cors) im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = src;
    });
  }
  function withWidth(u, w) { if (!u) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function Escribe(root) {
    var cfgNode = $('script[type="application/json"]', root);
    if (!cfgNode) return;
    var cfg;
    try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }
    this.root = root; this.cfg = cfg;
    this.esp = cfg.esp || 'michi';
    try { var q = new URLSearchParams(location.search).get('libro'); if (cfg.dual && (q === 'michi' || q === 'pupi')) this.esp = q; } catch (e) {}
    this.vals = {};
    this.photo = null; // {img, url, w, h}
    this.step = '9';
    this.build();
    var self = this;
    var go = function () { loadFont(cfg.font).then(function () { self.fitAll(); }); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '400px' });
      io.observe(root);
    } else go();
  }

  Escribe.prototype.libro = function () { return this.cfg.libros[this.esp]; };

  Escribe.prototype.build = function () {
    var self = this, cfg = this.cfg, root = this.root;
    var mount = $('[data-pp-mount]', root);
    mount.innerHTML = '';
    // pestañas especie
    if (cfg.dual) {
      var seg = el('div', { class: 'pp-seg', role: 'tablist', 'aria-label': '¿Para quién es?' });
      ['michi', 'pupi'].forEach(function (k) {
        var b = el('button', { type: 'button', role: 'tab', 'data-esp': k, 'aria-selected': k === self.esp ? 'true' : 'false' }, k === 'michi' ? '🐱 Tengo un michi' : '🐶 Tengo un pupi');
        if (k === self.esp) b.className = 'is-on';
        b.addEventListener('click', function () { self.setEsp(k); });
        seg.appendChild(b);
      });
      mount.appendChild(seg);
      this.seg = seg;
    }
    // pasos (solo celular)
    var steps = el('div', { class: 'pp-steps', role: 'tablist', 'aria-label': 'Páginas' });
    steps.innerHTML = '<button type="button" class="is-on" data-step="9" role="tab" aria-selected="true">1 · Su nombre<span class="pp-ok">✓</span></button>' +
      '<button type="button" data-step="8" role="tab" aria-selected="false">2 · Cómo llegó<span class="pp-ok">✓</span></button>';
    $all('button', steps).forEach(function (b) { b.addEventListener('click', function () { self.setStep(b.getAttribute('data-step'), true); }); });
    mount.appendChild(steps);
    this.steps = steps;

    var spread = el('div', { class: 'pp-spread', 'data-step': '9' });
    this.spread = spread;
    this.pages = {};
    ['8', '9'].forEach(function (n) {
      var pg = el('div', { class: 'pp-page pp-page--' + n, 'data-page': n });
      var img = el('img', { class: 'pp-page__img', alt: '', width: '1000', height: '1500', loading: 'lazy', decoding: 'async' });
      pg.appendChild(img);
      var geo = GEO['p' + n];
      geo.fields.forEach(function (f) {
        var inp = el('input', {
          class: 'pp-f' + (f.k === 'nombre' ? ' pp-f--nombre' : ''), type: 'text', name: 'pp_' + f.k, autocomplete: 'off', autocapitalize: f.k === 'nombre' ? 'words' : 'sentences',
          spellcheck: 'false', maxlength: f.k === 'nombre' ? '22' : '44', enterkeyhint: 'next', 'aria-label': f.lbl, placeholder: f.ph,
          style: 'left:' + f.x / 10 + '%;top:' + f.y / 15 + '%;width:' + f.w / 10 + '%;height:' + f.h / 15 + '%;--fs:' + f.fs
        });
        inp.addEventListener('input', function () { self.onInput(f.k, inp.value); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.focusNext(f.k); } });
        inp.addEventListener('focus', function () { if (!self.started) { self.started = true; track('inicio', { libro: self.esp }); } });
        pg.appendChild(inp);
        self['in_' + f.k] = inp;
      });
      if (n === '9') {
        self.tags = [];
        for (var t = 0; t < 4; t++) { var sp = el('span', { class: 'pp-tag', 'aria-hidden': 'true' }); pg.appendChild(sp); self.tags.push(sp); }
      }
      if (n === '8') {
        var fg = geo.foto;
        var lab = el('label', { class: 'pp-foto', style: 'left:' + fg.x / 10 + '%;top:' + fg.y / 15 + '%;width:' + fg.w / 10 + '%;height:' + fg.h / 15 + '%' });
        lab.innerHTML = '<input type="file" accept="image/*" aria-label="Agregar la foto del primer encuentro">' +
          '<span class="pp-foto__hint"><span class="pp-foto__ico">📷</span>Toca aquí para pegar su foto<small>Se queda en tu celular, no la subimos</small></span>' +
          '<span class="pp-print"><img alt="Foto del primer encuentro"></span>';
        var x = el('button', { type: 'button', class: 'pp-foto__x', 'aria-label': 'Quitar la foto' }, '✕');
        x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.setPhoto(null); });
        lab.appendChild(x);
        var fi = $('input', lab);
        fi.addEventListener('change', function () { if (fi.files && fi.files[0]) self.readPhoto(fi.files[0]); fi.value = ''; });
        pg.appendChild(lab);
        self.fotoBox = lab;
      }
      self.pages[n] = pg;
    });
    // en escritorio: 8 a la izquierda, 9 a la derecha
    spread.appendChild(this.pages['8']);
    spread.appendChild(this.pages['9']);
    mount.appendChild(spread);

    var next = el('button', { type: 'button', class: 'pp-next' }, 'Siguiente: cuéntanos cómo llegó →');
    next.addEventListener('click', function () { self.setStep('8', true); });
    mount.appendChild(next);
    this.nextBtn = next;

    Object.keys(CHIPS).forEach(function (k) {
      var box = el('div', { class: 'pp-chips', 'data-for': k });
      box.appendChild(el('p', null, k === 'adoptado' ? '¿Fue adoptado, rescatado o llegó solo?' : '¿Te eligió o tú a él?'));
      CHIPS[k].forEach(function (txt) {
        var b = el('button', { type: 'button' }, esc(txt));
        b.addEventListener('click', function () {
          var inp = self['in_' + k]; inp.value = txt; self.onInput(k, txt);
          $all('button', box).forEach(function (o) { o.classList.toggle('is-on', o === b); });
        });
        box.appendChild(b);
      });
      mount.appendChild(box);
      self['chips_' + k] = box;
    });

    var cta = el('div', { class: 'pp-esc__cta' });
    this.ctaWrap = cta;
    mount.appendChild(cta);
    this.renderCta();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { self.fitAll(); });
      ro.observe(this.pages['8']); ro.observe(this.pages['9']);
    } else window.addEventListener('resize', function () { self.fitAll(); });

    this.applyEsp();
    this.setStep('9', false);
    // pista visual en el nombre cuando la sección aparece
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io2.disconnect(); if (!self.vals.nombre) { self.in_nombre.classList.add('is-hint'); } }
      }, { threshold: .5 });
      io2.observe(this.pages['9']);
    }
  };

  Escribe.prototype.renderCta = function () {
    var self = this, cfg = this.cfg, lb = this.libro(), cta = this.ctaWrap;
    cta.innerHTML = '';
    var name = this.vals.nombre ? clean(this.vals.nombre, 22) : '';
    var nm = name ? 'la historia de <span class="pp-name-hl">' + esc(name.length > 16 ? name.slice(0, 15) + '…' : name) + '</span>' : 'su historia';
    if (cfg.modo === 'pack') {
      var b = el('button', { type: 'button', class: 'pp-btn' }, '<span>Quiero empezar ' + nm + ' →</span>');
      b.addEventListener('click', function () { self.remember(); track('cta', { libro: self.esp, tipo: 'pack' }); goBuy(); });
      cta.appendChild(b);
    } else {
      var f = el('form', { method: 'post', action: '/cart/add', 'accept-charset': 'UTF-8' });
      f.innerHTML = '<input type="hidden" name="id" value="' + lb.variante + '"><input type="hidden" name="quantity" value="1">' +
        '<input type="hidden" name="properties[_origen]" value="escribe-su-historia">' +
        (name ? '<input type="hidden" name="properties[_mascota]" value="' + esc(name) + '">' : '');
      var sb = el('button', { type: 'submit', class: 'pp-btn' }, '<span>' + (lb.disponible ? 'Quiero empezar ' + nm + ' · ' + esc(lb.precio) : 'Agotado por ahora') + '</span>');
      if (!lb.disponible) sb.disabled = true;
      f.appendChild(sb);
      f.addEventListener('submit', function () { self.remember(); track('cta', { libro: self.esp, nombre: name ? 1 : 0 }); });
      cta.appendChild(f);
    }
    var g = el('button', { type: 'button', class: 'pp-btn pp-btn--sec' }, '📸 Guardar su página para compartir');
    g.addEventListener('click', function () { self.share(); });
    cta.appendChild(g);
    cta.appendChild(el('p', { class: 'pp-note' }, 'El libro llega en blanco para que lo escribas tú, con tu letra. ' + (cfg.modo === 'pack' ? '' : '🚚 Envío gratis a todo Chile.')));
  };

  Escribe.prototype.remember = function () {
    store('pp_mascota', this.vals.nombre ? clean(this.vals.nombre, 22) : '');
    store('pp_esp', this.esp);
  };

  Escribe.prototype.setEsp = function (k) {
    if (k === this.esp) return;
    this.esp = k;
    if (this.seg) $all('button', this.seg).forEach(function (b) { var on = b.getAttribute('data-esp') === k; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    this.applyEsp();
    this.renderCta();
    var ev; try { ev = new CustomEvent('pp:esp', { detail: k }); } catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('pp:esp', false, false, k); }
    document.dispatchEvent(ev);
    track('especie', { libro: k });
  };

  Escribe.prototype.applyEsp = function () {
    var lb = this.libro(), self = this;
    this.root.setAttribute('data-esp', this.esp);
    $all('[data-pp-libro]', this.root).forEach(function (n) { n.textContent = lb.nombre; });
    ['8', '9'].forEach(function (n) {
      var img = $('.pp-page__img', self.pages[n]);
      var src = lb.img['p' + n];
      img.src = withWidth(src, 700);
      img.srcset = withWidth(src, 500) + ' 500w, ' + withWidth(src, 700) + ' 700w, ' + withWidth(src, 1000) + ' 1000w';
      img.sizes = '(min-width: 900px) 440px, 92vw';
      img.alt = n === '8' ? 'Página 8 del Libro ' + lb.nombre + ': ¿Cómo llegó tu ' + self.esp + '?' : 'Página 9 del Libro ' + lb.nombre + ': Su nombre y sus apodos';
    });
    var deco = $all('[data-pp-deco]', this.root);
    deco.forEach(function (d) { var src = d.getAttribute('data-' + self.esp); if (src) d.src = src; });
    this.updateTags();
  };

  Escribe.prototype.setStep = function (s, user) {
    this.step = s;
    this.spread.setAttribute('data-step', s);
    $all('button', this.steps).forEach(function (b) { var on = b.getAttribute('data-step') === s; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    this.chips_adoptado.classList.toggle('is-on', s === '8');
    this.chips_eligio.classList.toggle('is-on', s === '8');
    this.updateNext();
    if (user) {
      var top = this.steps.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * .5) this.steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.fitAll();
  };

  Escribe.prototype.updateNext = function () {
    this.nextBtn.classList.toggle('is-on', this.step === '9' && !!this.vals.nombre);
    var done9 = !!this.vals.nombre, done8 = !!(this.vals.donde || this.vals.quien || this.vals.adoptado || this.vals.eligio || this.photo);
    var bs = $all('button', this.steps);
    bs[0].classList.toggle('is-done', done9); bs[1].classList.toggle('is-done', done8);
  };

  Escribe.prototype.focusNext = function (k) {
    var order = ['nombre', 'porque', 'apodo1', 'apodo2', 'apodo3', 'donde', 'quien', 'adoptado', 'eligio'];
    var i = order.indexOf(k);
    if (k === 'apodo3' && window.innerWidth < 900) { this.setStep('8', true); }
    var nx = order[i + 1];
    if (nx) { var inp = this['in_' + nx]; if (inp) inp.focus({ preventScroll: false }); }
    else this['in_' + k].blur();
  };

  Escribe.prototype.onInput = function (k, v) {
    this.vals[k] = v;
    if (k === 'nombre') {
      this.in_nombre.classList.remove('is-hint');
      this.updateTags();
      clearTimeout(this._ct);
      var self = this;
      this._ct = setTimeout(function () { self.renderCta(); self.remember(); self.injectMain(); }, 220);
      if (v && !this._named) { this._named = true; track('nombre', { libro: this.esp }); }
    }
    this.fit(this['in_' + k]);
    this.updateNext();
  };

  // Lleva el nombre al formulario principal de la ficha (si existe) como propiedad oculta
  Escribe.prototype.injectMain = function () {
    if (this.cfg.modo !== 'producto') return;
    var name = this.vals.nombre ? clean(this.vals.nombre, 22) : '';
    $all('form[action*="/cart/add"]').forEach(function (f) {
      if (f.closest('[data-pp-esc]') || f.closest('[data-pp-hj]') || f.closest('.pp-rd')) return;
      var h = f.querySelector('input[name="properties[_mascota]"]');
      if (!name) { if (h) h.remove(); return; }
      if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[_mascota]'; f.appendChild(h); }
      h.value = name;
    });
  };

  Escribe.prototype.fitAll = function () {
    var self = this;
    ['8', '9'].forEach(function (n) {
      var pg = self.pages[n];
      var w = pg.getBoundingClientRect().width;
      if (w) pg.style.setProperty('--pw', w.toFixed(1));
    });
    $all('.pp-f', this.root).forEach(function (i) { self.fit(i); });
    this.updateTags();
  };

  // Achica la letra si el texto no cabe en la línea
  var measureCtx = null;
  function textWidth(txt, px, weight) {
    if (!measureCtx) measureCtx = document.createElement('canvas').getContext('2d');
    measureCtx.font = weight + ' ' + px + 'px "' + FONT + '", cursive';
    return measureCtx.measureText(txt).width;
  }
  Escribe.prototype.fit = function (inp) {
    if (!inp) return;
    inp.style.fontSize = '';
    var v = inp.value; if (!v) return;
    var cs = getComputedStyle(inp);
    var px = parseFloat(cs.fontSize), avail = inp.clientWidth * .92;
    var w = textWidth(v, px, cs.fontWeight || 600);
    if (w > avail && avail > 0) inp.style.setProperty('font-size', Math.max(11, px * avail / w).toFixed(1) + 'px', 'important');
  };

  Escribe.prototype.updateTags = function () {
    if (!this.tags) return;
    var pg = this.pages['9'];
    var pw = pg.getBoundingClientRect().width || 360;
    var name = clean(this.vals.nombre || '', 22);
    var conf = GEO.p9.tags[this.esp];
    this.tags.forEach(function (sp, i) {
      var t = conf[i];
      sp.style.left = t.x / 10 + '%'; sp.style.top = t.y / 15 + '%';
      sp.style.setProperty('--r', t.r + 'deg');
      var fs = t.s;
      if (name) { var w = textWidth(name, fs, 700); if (w > t.max) fs = Math.max(9, fs * t.max / w); }
      sp.style.fontSize = (pw * fs / 1000).toFixed(2) + 'px';
      sp.textContent = name;
      sp.classList.toggle('is-on', !!name);
    });
  };

  Escribe.prototype.readPhoto = function (file) {
    var self = this;
    if (!/^image\//.test(file.type || 'image/')) return;
    var url = URL.createObjectURL(file);
    loadImg(url).then(function (im) {
      self.setPhoto({ img: im, url: url, w: im.naturalWidth, h: im.naturalHeight });
      track('foto', { libro: self.esp });
    }).catch(function () { URL.revokeObjectURL(url); });
  };

  Escribe.prototype.photoRect = function () {
    // rectángulo de la foto impresa dentro del recuadro (en px de página 1000 x 1500)
    var b = GEO.p8.foto, p = this.photo;
    var port = p && p.h > p.w * 1.05;
    var ow = port ? 300 : 440, oh = port ? 400 : 345;
    return { cx: b.x + b.w / 2, cy: b.y + b.h / 2 + 6, w: ow, h: oh, rot: port ? 2.5 : -3, port: port };
  };

  Escribe.prototype.setPhoto = function (p) {
    if (this.photo && this.photo.url && (!p || p.url !== this.photo.url)) { try { URL.revokeObjectURL(this.photo.url); } catch (e) {} }
    this.photo = p;
    var box = this.fotoBox, pr = $('.pp-print', box), im = $('img', pr);
    box.classList.toggle('has-photo', !!p);
    if (p) {
      var r = this.photoRect(), b = GEO.p8.foto;
      pr.classList.toggle('is-port', r.port);
      pr.style.width = (r.w / b.w * 100) + '%';
      pr.style.height = (r.h / b.h * 100) + '%';
      im.src = p.url;
    } else { im.removeAttribute('src'); }
    this.updateNext();
  };

  /* ---------- Imagen para compartir (1080 x 1920) ---------- */
  function fitFont(ctx, txt, weight, size, maxW) {
    ctx.font = weight + ' ' + size + 'px "' + FONT + '", cursive';
    var w = ctx.measureText(txt).width;
    if (w > maxW) { size = Math.max(10, size * maxW / w); ctx.font = weight + ' ' + size + 'px "' + FONT + '", cursive'; }
    return size;
  }
  Escribe.prototype.drawPage = function (n, pageImg) {
    var c = document.createElement('canvas'); c.width = 1000; c.height = 1500;
    var ctx = c.getContext('2d');
    ctx.drawImage(pageImg, 0, 0, 1000, 1500);
    var self = this, geo = GEO['p' + n];
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = PEN;
    geo.fields.forEach(function (f, i) {
      var v = clean(self.vals[f.k] || '', 44); if (!v) return;
      var wt = f.w8 || 600;
      var size = fitFont(ctx, v, wt, f.fs, f.w * .9);
      ctx.save();
      ctx.translate(f.x + f.w / 2, f.y + f.h / 2 + size * .06);
      ctx.rotate(((i % 2 ? .6 : -.5) * Math.PI) / 180);
      ctx.globalAlpha = .94;
      ctx.fillText(v, 0, 0);
      ctx.restore();
    });
    if (n === '9') {
      var name = clean(this.vals.nombre || '', 22);
      if (name) {
        ctx.fillStyle = '#4b3a35';
        GEO.p9.tags[this.esp].forEach(function (t) {
          ctx.save(); ctx.translate(t.x, t.y); ctx.rotate(t.r * Math.PI / 180);
          fitFont(ctx, name, 700, t.s, t.max); ctx.globalAlpha = .9; ctx.fillText(name, 0, 0); ctx.restore();
        });
      }
    }
    if (n === '8' && this.photo) {
      var r = this.photoRect(), im = this.photo.img;
      ctx.save();
      ctx.translate(r.cx, r.cy); ctx.rotate(r.rot * Math.PI / 180);
      ctx.shadowColor = 'rgba(40,30,10,.28)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 6;
      ctx.fillStyle = '#fff'; ctx.fillRect(-r.w / 2, -r.h / 2, r.w, r.h);
      ctx.shadowColor = 'transparent';
      var ix = -r.w / 2 + r.w * .03, iy = -r.h / 2 + r.w * .03, iw = r.w - r.w * .06, ih = r.h - r.w * .03 - r.h * .085;
      var s = Math.max(iw / im.naturalWidth, ih / im.naturalHeight), sw = iw / s, sh = ih / s;
      ctx.drawImage(im, (im.naturalWidth - sw) / 2, (im.naturalHeight - sh) / 2, sw, sh, ix, iy, iw, ih);
      ctx.fillStyle = 'rgba(236,224,193,.88)';
      [[-1, -34], [1, 34]].forEach(function (a) {
        ctx.save(); ctx.translate(a[0] * (r.w / 2 - r.w * .02), -r.h / 2 + 4); ctx.rotate(a[1] * Math.PI / 180);
        ctx.fillRect(-r.w * .12, -r.h * .045, r.w * .24, r.h * .09); ctx.restore();
      });
      ctx.restore();
    }
    return c;
  };

  Escribe.prototype.makeStory = function () {
    var self = this, lb = this.libro();
    var srcs = [withWidth(lb.img.p9, 1000)];
    var has8 = !!(this.vals.donde || this.vals.quien || this.vals.adoptado || this.vals.eligio || this.photo);
    if (has8) srcs.push(withWidth(lb.img.p8, 1000));
    if (lb.ilu) srcs.push(lb.ilu);
    return loadFont(this.cfg.font).then(function () { return Promise.all(srcs.map(function (u) { return loadImg(u, true); })); }).then(function (ims) {
      var W = 1080, H = 1920, c = document.createElement('canvas'); c.width = W; c.height = H;
      var ctx = c.getContext('2d');
      var g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#FBF6EF'); g.addColorStop(1, '#F3EADB');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      var name = clean(self.vals.nombre || '', 22);
      ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#C97B3D'; ctx.font = '800 28px system-ui,-apple-system,"Segoe UI",Roboto,sans-serif';
      ctx.fillText(('LIBRO ' + lb.nombre + ' · PATITAS DE PAPEL').toUpperCase(), W / 2, 118);
      ctx.fillStyle = '#392f2a';
      if (name) {
        fitFont(ctx, 'La historia de', 600, 86, 900); ctx.fillText('La historia de', W / 2, 228);
        ctx.fillStyle = '#2F6F74'; fitFont(ctx, name, 700, 168, 960); ctx.fillText(name, W / 2, 392);
        ctx.fillStyle = '#392f2a'; fitFont(ctx, 'empieza hoy', 600, 86, 900); ctx.fillText('empieza hoy', W / 2, 488);
      } else {
        fitFont(ctx, 'Nuestra historia', 700, 120, 960); ctx.fillText('Nuestra historia', W / 2, 300);
        fitFont(ctx, 'empieza hoy', 600, 86, 900); ctx.fillText('empieza hoy', W / 2, 420);
      }
      var p9 = self.drawPage('9', ims[0]);
      function drawPageAt(cv, x, y, w, h, rot) {
        ctx.save(); ctx.translate(x + w / 2, y + h / 2); ctx.rotate(rot * Math.PI / 180);
        ctx.shadowColor = 'rgba(60,40,15,.25)'; ctx.shadowBlur = 34; ctx.shadowOffsetY = 14;
        ctx.fillStyle = '#fff'; ctx.fillRect(-w / 2, -h / 2, w, h); ctx.shadowColor = 'transparent';
        ctx.drawImage(cv, -w / 2, -h / 2, w, h); ctx.restore();
      }
      if (has8) {
        var p8 = self.drawPage('8', ims[1]);
        var pw = 492, ph = 738, top = 600, left = (W - pw * 2) / 2;
        ctx.save(); ctx.translate(W / 2, top + ph / 2); ctx.rotate(-1.2 * Math.PI / 180);
        ctx.shadowColor = 'rgba(60,40,15,.28)'; ctx.shadowBlur = 40; ctx.shadowOffsetY = 16;
        ctx.fillStyle = '#fff'; ctx.fillRect(-pw, -ph / 2, pw * 2, ph); ctx.shadowColor = 'transparent';
        ctx.drawImage(p8, -pw, -ph / 2, pw, ph); ctx.drawImage(p9, 0, -ph / 2, pw, ph);
        var gl = ctx.createLinearGradient(-30, 0, 30, 0); gl.addColorStop(0, 'rgba(60,40,15,0)'); gl.addColorStop(.5, 'rgba(60,40,15,.22)'); gl.addColorStop(1, 'rgba(60,40,15,0)');
        ctx.fillStyle = gl; ctx.fillRect(-30, -ph / 2, 60, ph);
        ctx.restore();
      } else {
        drawPageAt(p9, (W - 720) / 2, 590, 720, 1080, -1.6);
      }
      ctx.fillStyle = '#2F6F74'; ctx.font = '800 38px system-ui,-apple-system,"Segoe UI",Roboto,sans-serif';
      ctx.fillText('patitasdepapel.cl', W / 2, has8 ? 1500 : 1790);
      ctx.fillStyle = '#5f6f78'; ctx.font = '600 28px system-ui,-apple-system,"Segoe UI",Roboto,sans-serif';
      ctx.fillText('Escribe su historia con tu letra', W / 2, has8 ? 1552 : 1840);
      var ilu = ims[ims.length - 1];
      if (lb.ilu && ilu && ilu !== ims[0]) {
        var ih = has8 ? 250 : 230, iw = ilu.naturalWidth * ih / ilu.naturalHeight;
        if (has8) ctx.drawImage(ilu, (W - iw) / 2, 1610, iw, ih);
        else ctx.drawImage(ilu, W - iw - 40, H - ih - 150, iw, ih);
      }
      return c;
    });
  };

  Escribe.prototype.share = function () {
    var self = this;
    track('guardar', { libro: this.esp, nombre: this.vals.nombre ? 1 : 0, foto: this.photo ? 1 : 0 });
    var m = $('.pp-share') || buildShareModal();
    var box = $('.pp-share__box', m);
    var name = clean(this.vals.nombre || '', 22);
    $('.pp-share__body', m).innerHTML = '<div class="pp-share__load">Preparando su página…</div>';
    openModal(m);
    this.makeStory().then(function (c) {
      c.toBlob(function (blob) {
        if (!blob) return;
        var fname = 'historia-de-' + (name || self.esp).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.png';
        var url = URL.createObjectURL(blob);
        var body = $('.pp-share__body', m);
        body.innerHTML = '';
        var img = el('img', { src: url, alt: name ? 'La historia de ' + name + ' empieza hoy' : 'Su página del libro' });
        body.appendChild(img);
        var btns = el('div', { class: 'pp-share__btns' });
        var file = null;
        try { file = new File([blob], fname, { type: 'image/png' }); } catch (e) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          var sh = el('button', { type: 'button', class: 'pp-btn' }, 'Compartir en Instagram o WhatsApp');
          sh.addEventListener('click', function () {
            navigator.share({ files: [file], title: name ? 'La historia de ' + name : 'Nuestra historia', text: 'La historia se escribe hoy 🐾 patitasdepapel.cl' }).then(function () { track('compartir', { libro: self.esp }); }).catch(function () {});
          });
          btns.appendChild(sh);
        }
        var dl = el('a', { class: 'pp-btn' + (btns.children.length ? ' pp-btn--sec' : ''), href: url, download: fname }, 'Descargar imagen');
        dl.addEventListener('click', function () { track('descargar', { libro: self.esp }); });
        btns.appendChild(dl);
        body.appendChild(btns);
        body.appendChild(el('p', { class: 'pp-share__h', style: 'margin-top:10px' }, 'Si no se descarga, mantén presionada la imagen y elige «Guardar imagen». Etiquétanos en <b>@editorialpatitasdepapel</b> 💛'));
      }, 'image/png');
    }).catch(function () {
      $('.pp-share__body', m).innerHTML = '<div class="pp-share__load">No pudimos preparar la imagen. Inténtalo de nuevo.</div>';
    });
  };

  function buildShareModal() {
    var m = el('div', { class: 'pp-share', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Guardar su página' });
    m.innerHTML = '<div class="pp-share__box"><button type="button" class="pp-share__x" aria-label="Cerrar">✕</button>' +
      '<p class="pp-share__t">Así se ve su historia</p><p class="pp-share__h">Guárdala o compártela en tus historias.</p><div class="pp-share__body"></div></div>';
    $('.pp-share__x', m).addEventListener('click', function () { closeModal(m); });
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(m); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) closeModal(m); });
    document.body.appendChild(m);
    return m;
  }
  var lastFocus = null;
  function openModal(m) { lastFocus = document.activeElement; m.classList.add('is-open'); document.documentElement.classList.add('pp-lock'); var x = $('.pp-share__x', m); if (x) x.focus(); }
  function closeModal(m) { m.classList.remove('is-open'); document.documentElement.classList.remove('pp-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }

  function goBuy() {
    var btn = document.querySelector('button.Sd_addProduct') || document.querySelector('form[action*="/cart/add"] [type=submit]');
    if (btn && btn.offsetParent) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function init() { $all('[data-pp-esc]').forEach(function (r) { if (!r.__pp) { r.__pp = new Escribe(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
